module.exports = __webpack_public_path__ + "static/media/event2.7adc8aec.jpeg";